(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hoya-bestsellers')) {
    customElements.define('hoya-bestsellers', class extends HTMLElement {
      connectedCallback() {
        if (this.controller || !this.dataset.collectionUrl) return;
        this.controller = new AbortController();
        this.dataset.state = 'loading';
        this.refreshProducts();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }

      async refreshProducts() {
        const timeout = setTimeout(() => this.controller?.abort(), 8000);

        try {
          let url = new URL(this.dataset.collectionUrl, window.location.origin);
          url.searchParams.set('sort_by', 'best-selling');
          url.searchParams.set('section_id', 'featured-collections');

          const previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
          if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);

          const current = this.querySelector('[data-hoya-products]');
          const limit = Number(this.dataset.productsCount) || 8;
          const collectionPath = url.pathname;
          const visitedPages = new Set();
          let replacement;

          while (url) {
            if (url.origin !== window.location.origin || url.pathname !== collectionPath || visitedPages.has(url.href)) {
              throw new Error('Invalid collection pagination');
            }
            visitedPages.add(url.href);
            const response = await fetch(url, { signal: this.controller.signal });
            if (!response.ok) throw new Error('Unable to refresh collection preview');

            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const result = html.querySelector('[data-hoya-bestseller-result]');
            const pageProducts = result?.querySelector('[data-hoya-products]');

            if (!pageProducts || !current || result.dataset.collectionHandle !== this.dataset.collectionHandle || result.dataset.sort !== 'best-selling') {
              throw new Error('Invalid collection preview');
            }

            if (!replacement || !replacement.querySelector('product-card')) {
              replacement = pageProducts;
            } else {
              const carousel = replacement.querySelector('scroll-carousel') || replacement;
              pageProducts.querySelectorAll('product-card').forEach(card => carousel.append(card));
            }

            if (replacement.querySelectorAll('product-card').length >= limit || !result.dataset.nextPage) break;

            url = new URL(result.dataset.nextPage, window.location.origin);
            url.searchParams.set('sort_by', 'best-selling');
            url.searchParams.set('section_id', 'featured-collections');
            if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
          }

          if (!this.isConnected || current.contains(document.activeElement) || current.querySelector('quick-buy-modal[open]')) {
            this.dataset.state = 'fallback';
            return;
          }

          Array.from(replacement.querySelectorAll('product-card')).slice(limit).forEach(card => card.remove());

          // Namespace native card and carousel IDs for products appearing in multiple tabs.
          const ids = new Map();
          replacement.querySelectorAll('[id]').forEach(element => {
            const oldId = element.id;
            const newId = oldId + '--' + this.id;
            ids.set(oldId, newId);
            element.id = newId;
          });
          replacement.querySelectorAll('*').forEach(element => {
            ['aria-controls', 'aria-labelledby', 'aria-describedby', 'for', 'form', 'observe-form'].forEach(attribute => {
              const value = element.getAttribute(attribute);
              if (value) element.setAttribute(attribute, value.split(' ').map(id => ids.get(id) || id).join(' '));
            });
          });

          current.replaceWith(replacement);
          this.dataset.state = 'loaded';
        } catch (error) {
          // Keep the server-rendered, available products when the refresh cannot finish.
          if (this.isConnected) this.dataset.state = 'fallback';
        } finally {
          clearTimeout(timeout);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
